import axios from 'axios'
// import qs from 'qs'

export const reportService = ({
  getParticipantProgressData (token, cohortId) {
    return axios.get('/api/Report/GetParticipantProgressData?cohortId=' + cohortId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getMeetingMentorGoalActionsData (token, cohortId) {
    return axios.get('/api/Report/GoalsAndActionsReport?cohortId=' + cohortId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getAssessmentMCQReport (token, cohortId) {
    return axios.get('/api/Report/GetAssessmentMCQReportMatrix?cohortId=' + cohortId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getAssessmentReflectionReport (token, cohortId) {
    return axios.get('/api/Report/GetAssessmentReflectionReportMatrix?cohortId=' + cohortId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getMeetingMentorReport (token, cohortId) {
    return axios.get('/api/Report/MeetingMentor?cohortId=' + cohortId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getReviewReport (token, cohortId) {
    return axios.get('/api/Report/Review?cohortId=' + cohortId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getMMConsolidatedReport (token, cohortId, startDate, endDate) {
    return axios.get('/api/Report/ScheduledMeetingsWeekWiseSummary?cohortId=' + cohortId + '&startDate=' + startDate + '&endDate=' + endDate, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getDiscussionPosts (token, userCohortId) {
    return axios.get('/api/Report/GetDiscussionPosts?UserCohortId=' + userCohortId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getChallengesTaken (token, userCohortId) {
    return axios.get('/api/Report/GetChallengesData?UserCohortId=' + userCohortId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getDiscussionReportData (token, cohortId) {
    return axios.get('/api/Report/GetDiscussionReportData?CohortId=' + cohortId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getDiscussionPostComments (token, rdUserResponseId) {
    return axios.get('/api/Report/GetDiscussionPostComments?RDUserResponseId=' + rdUserResponseId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getDiscussionPostLikes (token, rdUserResponseId) {
    return axios.get('/api/Report/GetDiscussionPostLikes?RDUserResponseId=' + rdUserResponseId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getDeepDiveParticipantData (token, CohortId) {
    return axios.get('/api/Report/GetDeepDiveParticipantData?CohortId=' + CohortId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getDeepDiveViewsData (token, CohortId) {
    return axios.get('/api/Report/GetDeepDiveViewsData?CohortId=' + CohortId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getChallengeParticipantProgressQuantData (token, cohortId, subType = 0) {
    return axios.get('/api/Report/GetChallengeParticipantProgressQuantData?cohortId=' + cohortId + '&subType=' + subType, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getMCQReportData (token, cohortId) {
    return axios.get('/api/Report/GetMCQReportData?cohortId=' + cohortId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getParticipantMCQs (token, cohortId, mcqQuestionId) {
    return axios.get('/api/Report/GetParticipantMCQs?cohortId=' + cohortId + '&mcqQuestionId=' + mcqQuestionId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getChallengeSkillAssessmentData (token, userId, cohortId, subType = 0) {
    return axios.get('/api/Report/GetChallengeSkillAssessmentData?UserId=' + userId + '&CohortId=' + cohortId + '&subType=' + subType, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getChallengeParticipantProgressSummary (token, cohortId, startDate, endDate, subType = 0) {
    return axios.get('/api/Report/GetChallengeParticipantProgressSummary?cohortId=' + cohortId + '&startDate=' + startDate + '&endDate=' + endDate + '&subType=' + subType, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getChallengeParticipantProgressSummaryForCSV (token, cohortId, startDate, endDate, subType = 0) {
    return axios.post('/api/Report/GetChallengeParticipantProgressSummary?cohortId=' + cohortId + '&startDate=' + startDate + '&endDate=' + endDate + '&subType=' + subType, null, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getChallengeParticipantProgressData (token, cohortId, subType = 0) {
    return axios.get('/api/Report/GetChallengeParticipantProgressData?cohortId=' + cohortId + '&subType=' + subType, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getChallengeParticipantProgressDataForCSV (token, cohortId, subType = 0) {
    return axios.post('/api/Report/GetChallengeParticipantProgressData?cohortId=' + cohortId + '&subType=' + subType, null, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getLessonWiseProgressReport (token, cohortId) {
    return axios.get('/api/Report/GetLessonWiseProgressReport?cohortId=' + cohortId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getLessonWiseProgressReportForCSV (token, cohortId) {
    return axios.post('/api/Report/GetLessonWiseProgressReport?cohortId=' + cohortId, null, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getSendGridStats (token, senderEmail, startDate, endDate) {
    return axios.get('/api/Report/GetSendGridStats?senderEmail=' + senderEmail + '&startDate=' + startDate + '&endDate=' + endDate, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getSendGridStatsSummary (token, startDate, endDate) {
    return axios.get('/api/Report/GetSendGridStatsSummary?&startDate=' + startDate + '&endDate=' + endDate, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getM365Reports (token, moduleId, groupCourseMasterId, cohortId) {
    return axios.get('/api/M365/Report/Summary?moduleId=' + moduleId + '&groupCourseMasterId=' + groupCourseMasterId + '&cohortId=' + cohortId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getMissionReports (token, cohortId) {
    return axios.get('/api/Report/GetMissionsReport?cohortId=' + cohortId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getMissionReportForExport (token, cohortId) {
    return axios.post('/api/Report/GetMissionsReport?cohortId=' + cohortId, null, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getALGReports (token, cohortId) {
    return axios.get('/api/Report/GetAdaptiveGameReport?cohortId=' + cohortId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getALGReportsForExport (token, cohortId) {
    return axios.post('/api/Report/GetAdaptiveGameReport?cohortId=' + cohortId, null, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getVATConsumptionReports (token, cohortId) {
    return axios.get('/api/Report/VATConsumption?cohortId=' + cohortId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getVATConsumptionForExport (token, cohortId) {
    return axios.post('/api/Report/VATConsumption?cohortId=' + cohortId, null, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getDiscussionReportDataForCSV (token, cohortId) {
    return axios.post('/api/Report/GetDiscussionReportData?CohortId=' + cohortId, null, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getAchievedMilestoneUsingGroup (token, groupId, needToExport, selectedMilestoneTitleObj = null) {
    var requestUrl = ''
    if (selectedMilestoneTitleObj !== undefined && selectedMilestoneTitleObj !== null && selectedMilestoneTitleObj !== 'null' && selectedMilestoneTitleObj !== '') {
      requestUrl = '/api/Report/ConsolidatedMilestones?groupId=' + groupId + '&milestoneId=' + selectedMilestoneTitleObj.MilestoneId
    } else {
      requestUrl = '/api/Report/ConsolidatedMilestones?groupId=' + groupId
    }
    if (needToExport) {
      return axios.post(requestUrl, null, {headers: {'Authorization': 'Bearer ' + token}})
    } else {
      return axios.get(requestUrl, {headers: {'Authorization': 'Bearer ' + token}})
    }
  },
  getAchievedMilestoneUsingMilestoneAndGroup (token, groupId, milestoneId, needToExport, selectedMilestoneTitleObj = null) {
    var requestUrl = ''
    if (selectedMilestoneTitleObj !== undefined && selectedMilestoneTitleObj !== null && selectedMilestoneTitleObj !== 'null' && selectedMilestoneTitleObj !== '') {
      requestUrl = '/api/Report/MilestoneWise?groupId=' + groupId + '&MilestoneInfoId=' + milestoneId + '&milestoneId=' + selectedMilestoneTitleObj.MilestoneId
    } else {
      requestUrl = '/api/Report/MilestoneWise?groupId=' + groupId + '&MilestoneInfoId=' + milestoneId
    }
    if (needToExport) {
      return axios.post(requestUrl, null, {headers: {'Authorization': 'Bearer ' + token}})
    } else {
      return axios.get(requestUrl, {headers: {'Authorization': 'Bearer ' + token}})
    }
  },
  getMomentsReports (token, courseMasterId, fromStartTS) {
    return axios.get('/api/Report/MomentsReport?CourseMasterId=' + courseMasterId + '&fromDate=' + fromStartTS, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getAggricateCerficiateReport (token, groupId, groupCourseId, cohortId) {
    return axios.get('/api/UserCertificate/GetAggregatedCertficateGCCData?GroupId=' + groupId + '&GroupCourseId=' + groupCourseId + '&CohortId=' + cohortId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getUserMatricesCerficiateReport (token, groupId, groupCourseId, cohortId) {
    return axios.get('/api/UserCertificate/ListCertificates?GroupId=' + groupId + '&GroupCourseId=' + groupCourseId + '&CohortId=' + cohortId + '&GroupOnly=false', {headers: {'Authorization': 'Bearer ' + token}})
  },
  getAggricateCerficiateReportForGroup (token, groupId) {
    return axios.get('/api/UserCertificate/GetAggregatedCertficateData?GroupId=' + groupId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getUserMatricesCerficiateReportForGroup (token, groupId) {
    return axios.get('/api/UserCertificate/ListCertificates?GroupId=' + groupId + '&GroupOnly=true', {headers: {'Authorization': 'Bearer ' + token}})
  },
  getElementWiseProgressReportForCSV (token, objToPost) {
    return axios.post('/api/ReportV2/ElementWiseReport', objToPost, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getLearnPerformReport (token, cohortId) {
    return axios.get('/api/Report/LearnAndPerform?cohortId=' + cohortId, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/report-service.js